import { useCookies } from "react-cookie";
import Image from "@/components/Atoms/Image";
import { ButtonMaster } from "@/components/Atoms/Buttons";
import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import { MultiPurposeTitle } from "@/atoms/Title";
import styles from "./index.module.scss";
import { CustomUnderline, Underline } from "@/components/Atoms/Underline";
import { FullBackgroundImage } from "@/components/Molecules/ImageCard";
import { useTranslation } from "next-i18next";
import { resolvePortfolioBackgroundStyle } from "@/lib/resolve-background-color";

interface Props {
  siteConfig: any;
  redirectTo?: string;
}

export default function AgeGate({ siteConfig, redirectTo }: Props) {
  const [cookies, setCookie, removeCookie] = useCookies(["age-gate"]);

  const yesClick = () => {
    setCookie("age-gate", 1, { path: "/" });
    if (redirectTo) {
      window.location.href = redirectTo;
    } else {
      window.location.reload();
    }
  };

  const noClicked = () => {
    window.location.href = siteConfig.ageGateRedirectUrl;
  };

  if (siteConfig.logoPicker) {
    var logo = siteConfig.headerMenu.logo;
  } else {
    var logo = siteConfig.headerMenu.logoColour;
  }

  const { t } = useTranslation();
  const backgroundStyle = resolvePortfolioBackgroundStyle(
    siteConfig.backgroundGrColor,
    siteConfig.agBackgroundColor
  );

  return (
    <div
      style={backgroundStyle}
      className={` ${styles.ageGatePage} relative mx-auto  flex flex-col items-center justify-center`}
    >
      <div className="w-full">
        <div className=" mx-auto  relative z-10 flex flex-col lg:gap-12">
          <div className={` lg:pt-12 pb-6  flex justify-center `}>
            {siteConfig?.headerMenu?.logoRatio ? (
              <Image
                className="h-[10rem] max-w-[90%] lg:h-[5rem] md:max-w-[40rem]"
                data={logo}
              />
            ) : (
              <Image
                className="h-[5rem] lg:h-[10rem] max-w-[20rem]"
                data={logo}
              />
            )}
          </div>

          <div className="w-full relative h-full flex justify-center">
            <div className="flex flex-col gap-4 lg:gap-8 px-12 items-center my-8 md:my-0 max-w-3xl">
              {siteConfig.ageGateWelcome && (
                <div className="flex flex-col items-center w-fit">
                  {" "}
                  <MultiPurposeTitle
                    layout={"center"}
                    tag="h2"
                    type="default"
                    data={siteConfig.ageGateWelcome}
                    color={siteConfig.agTaglineColor?.color}
                  />
                  {siteConfig.addTitleUnderline && (
                    <>
                      {siteConfig.customUnderlineAsset?.img ? (
                        <CustomUnderline
                          shape={siteConfig.customUnderlineAsset?.img}
                          color={siteConfig.underlineColor?.color}
                        />
                      ) : (
                        <Underline color={siteConfig.underlineColor?.color} />
                      )}
                    </>
                  )}
                </div>
              )}
              {siteConfig.backgroundType !== "full" && (
                <div className="w-full absolute h-[110%] bottom-0 m-auto z-[-1]">
                  <FullBackgroundImage
                    data={siteConfig.ageGateBackgroundImage?.url}
                  />
                </div>
              )}

              <MultiPurposeParagraph
                align={"center"}
                type="featured"
                data={siteConfig.ageGateTitle}
                color={siteConfig.agHeadingColor?.color}
              />
              <MultiPurposeParagraph
                align={"center"}
                type="default"
                data={siteConfig.ageGateContent}
                color={siteConfig.agHeadingColor?.color}
              />
              <MultiPurposeParagraph
                align={"center"}
                type="default"
                transform={"uppercase"}
                weight={"bold"}
                data={siteConfig.ageGateQuestion}
                color={siteConfig.agBodyColor?.color}
              />

              <div className="flex gap-2 md:gap-12 items-center w-auto flex-row justify-center   md:pb-12">
                <ButtonMaster
                  anim={""}
                  onClick={yesClick}
                  type={siteConfig.ageGateButton[0]?.buttonStyle}
                  cta={siteConfig.ageGateButton[0]?.typeColor?.color}
                  color={siteConfig.ageGateButton[0]?.labelColor?.color}
                  customIcon={siteConfig.ageGateButton[0]?.icon?.img}
                  customColor={siteConfig.ageGateButton[0]?.iconColor?.color}
                  target={``}
                  link={null}
                >
                  {t("yes")}
                </ButtonMaster>
                <ButtonMaster
                  anim={""}
                  onClick={noClicked}
                  type={siteConfig.ageGateButton[0]?.buttonStyle}
                  cta={siteConfig.ageGateButton[0]?.typeColor?.color}
                  color={siteConfig.ageGateButton[0]?.labelColor?.color}
                  customIcon={siteConfig.ageGateButton[0]?.icon?.img}
                  customColor={siteConfig.ageGateButton[0]?.iconColor?.color}
                  target={``}
                  link={null}
                >
                  {t("no")}
                </ButtonMaster>
              </div>
            </div>
          </div>
        </div>
      </div>
      {siteConfig.backgroundType !== "default" && (
        <div className="w-full absolute h-[100%] bottom-0 m-auto z-[-1]">
          <FullBackgroundImage data={siteConfig.ageGateBackgroundImage?.url} />
        </div>
      )}
    </div>
  );
}
